import React, { useEffect, useRef, useState } from 'react';
import { IContrast } from '@/store/models/image-editor-model';
import './contrast.less';

const ContrastView: React.FC<{
    contrast: IContrast;
    data: {
        viewWidth: number;
        viewHeight: number;
        stageWidth: number;
        stageHeight: number;
        scale?: number;
        image: HTMLImageElement;
    };
}> = ({
    contrast: { height = 0, width = 0, isShow },
    data: { viewWidth, viewHeight, stageWidth, stageHeight, scale = 1, image },
}) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const [opacity, setOpacity] = useState(0);

    const finalWidth = Math.max(viewWidth, stageWidth);
    const finalHeight = Math.max(viewHeight, stageHeight);

    useEffect(() => {
        if (!isShow || !width || !height || !image || !canvasRef.current) return;
        canvasRef.current.width = width;
        canvasRef.current.height = height;
        const ctx = canvasRef.current.getContext('2d');
        ctx?.drawImage(image, 0, 0, width, height);
        setOpacity(1);
    }, [image, height, width, isShow]);

    return (
        <div
            className="contrast-view-mask"
            style={{
                width: `${finalWidth}px`,
                height: `${finalHeight}px`,
                left: '50%',
                top: '50%',
                transform: `translate(-50%, -50%) scale(${1 / scale})`,
                opacity,
            }}
        >
            <div className="contrast-view" style={{ transform: `scale(${scale})` }}>
                <canvas ref={canvasRef} />
            </div>
        </div>
    );
};

export default React.memo(ContrastView);
